<template>
  <v-container fluid>
    <v-toolbar class="mb-2">
      <v-toolbar-title class="mr-3">
        Reporte de Stock
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <div>
        <v-tabs v-model="tabs" v-if="stocks && stocks.length > 0">
          <v-tab v-for="(tab) in getTabs" :key="tab.key">
            <div>{{ tab.title }}</div>
          </v-tab>
        </v-tabs>
      </div>

      <v-spacer></v-spacer>
      <v-btn @click="fetchStockDaily" :loading="loading" fab x-small class="mr-4"><v-icon>refresh</v-icon></v-btn>
      <div>
        <month-picker v-model="date" @input="fetchStockDaily" solo></month-picker>
      </div>
    </v-toolbar>

    <loading v-if="!ready"></loading>

    <v-row v-if="ready" justify="space-between" align="center">
      <v-col cols="12" sm="12">
        <v-tabs-items v-model="tabs" >
          <v-tab-item v-for="stock in stocks" :key="stock.id">
            <v-simple-table fixed-header :height="tableHeight">
              <thead>
              <tr>
                <th>Fecha</th>
                <th></th>
                <th v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id">
                  {{ item.product.shortName }}
                </th>
              </tr>
              </thead>

              <tbody v-for="stockDaily in getStocksDailyByBranch(stock.branch)" :key="stockDaily.id">
              <tr>
                <td :rowspan="getTypeStocksLength" style="border-bottom: 2px solid black">
                  {{ getDateFormat(stockDaily.date) }}
                </td>
                <td>Stock</td>
                <td
                    v-for="item in stock.items.filter(i => i.hide === false)"
                    :key="item.product.id"
                    :class="item.minimum >=  getProductInStock(stockDaily, item.product) ? 'red--text font-weight-bold' : 'black--text'"
                >
                  {{ getProductInStock(stockDaily, item.product) }}
                </td>
              </tr>

              <tr>
                <td>Reposición</td>
                <td v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id">
                  {{ getProductAdded(stockDaily, item.product) }}
                </td>
              </tr>
              <template v-if="isFactory || isHybrid">
                <tr v-for="branch of getBranchs" :key="branch.id">
                  <td>Envíos a {{ branch.name }}</td>
                  <td v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id">
                    {{ getProductSent(stockDaily, item.product, branch) || 0 }}
                  </td>
                </tr>
              </template>
              <template v-if="isSales || isHybrid">
                <tr>
                  <td>Vendidos</td>
                  <td v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id">
                    {{ getProductSold(stockDaily, item.product) }}
                  </td>
                </tr>
              </template>
              <tr>
                <td style="border-bottom: 2px solid black">Baja</td>
                <td v-for="item in stock.items.filter(i => i.hide === false)" :key="item.product.id"
                    style="border-bottom: 2px solid black">
                  {{ getProductRemoved(stockDaily, item.product) }}
                </td>
              </tr>

              </tbody>

            </v-simple-table>
          </v-tab-item>

          <!--TOTAL-->
          <v-tab-item key="total">
            <v-simple-table>
              <thead>
              <tr>
                <th>Fecha</th>
                <th></th>
                <th v-for="product in products" :key="product.id">
                  {{ product.shortName }}
                </th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="date in getStocksDailyDates" :key="date.toString()">
                <td>{{ getDateFormat(date) }}</td>
                <td>Stock</td>
                <td v-for="product in products" :key="product.id">
                  {{ getProductTotalInStock(date, product) }}
                </td>
              </tr>
              </tbody>

            </v-simple-table>
          </v-tab-item>

        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BranchProvider from "@/modules/delivery/providers/BranchProvider";
import StockProvider from "@/modules/delivery/providers/StockProvider";
import ProductProvider from "@/modules/delivery/providers/ProductProvider";
import {Dayjs, DayjsMixin} from "@dracul/dayjs-frontend"
import {Loading} from "@dracul/common-frontend"
import StockDailyProvider from "@/modules/delivery/providers/StockDailyProvider";
import MonthPicker from "@/modules/delivery/components/MonthPicker/MonthPicker";

export default {
  name: "StockReportPage",
  components: {MonthPicker, Loading},
  mixins: [DayjsMixin],
  data() {
    return {
      loading: false,
      tabs: 0,
      products: [],
      stocks: [],
      stocksDaily: [],
      date: Dayjs().format("YYYY-MM"),
      branchs: [],
      windowHeight: window.innerHeight,
      ready: false
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  async created() {
    await this.fetchProduct()
    await this.fetchStockDaily()
    await this.fetchStock()
    await this.fetchBranch()
    this.ready = true
  },
  computed: {
    tableHeight() {
      const availableHeight = this.windowHeight - 170
      return `${availableHeight}px`
    },
    getTabs() {
      let options = this.stocks.map(s => ({title: s.branch.name, role: s.branch.role, key: s.id}))
      // options.push({title: 'Total', id: 'total'})
      return options
    },
    getStockSelected() {
      return this.stocks[this.tabs]
    },
    getDates() {
      let dates = []
      let today = Dayjs(this.date, 'YYYY-MM')
      let endOfMonth = today.clone().add(1, 'month')
      let counter = 0
      while (endOfMonth.isAfter(today) && counter < 31) {
        dates.push(today.format('YYYY-MM-DD'))
        today = today.add(1, 'day')
        counter++
      }
      return dates
    },
    getStocksDailyByBranch() {
      return branch => {
        const stocksDailyByBranch = this.stocksDaily.filter(s => s.branch.id === branch.id)
        const allDates = this.getDates

        // Obtener la fecha actual
        let currentDate = Dayjs()

        // Verificar si el mes seleccionado es el mes actual
        let isCurrentMonth = Dayjs(this.date, 'YYYY-MM').format('YYYY-MM') === currentDate.format('YYYY-MM')

        // Crear un mapa de stockDaily por fecha para acceso rápido
        const stockDailyMap = {}
        stocksDailyByBranch.forEach(sd => {
          // Convertir el timestamp string a Date y luego a formato YYYY-MM-DD
          const dateObj = new Date(parseInt(sd.date))
          const dateStr = Dayjs(dateObj).format('YYYY-MM-DD')
          stockDailyMap[dateStr] = sd
        })

        // Filtrar las fechas si es el mes actual (solo hasta hoy + 1 día)
        let datesToProcess = allDates
        if (isCurrentMonth) {
          const tomorrowStr = currentDate.add(1, 'day').format('YYYY-MM-DD')
          datesToProcess = allDates.filter(date => {
            const dateObj = new Date(date)
            const tomorrowObj = new Date(tomorrowStr)
            return dateObj <= tomorrowObj
          })
        }

        // Generar array con todos los días del mes (o hasta hoy si es mes actual)
        const completeStockDaily = datesToProcess.map((date, index) => {
          if (stockDailyMap[date]) {
            // Si existe stockDaily para este día, usarlo
            return stockDailyMap[date]
          } else {
            // Si no existe, buscar el último día anterior con datos
            let previousStockDaily = null
            for (let i = index - 1; i >= 0; i--) {
              if (stockDailyMap[datesToProcess[i]]) {
                previousStockDaily = stockDailyMap[datesToProcess[i]]
                break
              }
            }

            if (previousStockDaily) {
              // Copiar el stockDaily anterior sin movimientos
              return {
                ...previousStockDaily,
                id: `${date}-${branch.id}`, // ID temporal para la key
                date: date, // Mantener como string YYYY-MM-DD
                items: previousStockDaily.items.map(item => ({
                  ...item,
                  added: 0,
                  removed: 0,
                  sold: 0,
                  sent: [],
                  initial_stock: item.ended_stock || item.initial_stock,
                  ended_stock: item.ended_stock || item.initial_stock
                }))
              }
            } else {
              // Primer día sin datos, crear estructura vacía
              return {
                id: `${date}-${branch.id}`,
                branch: branch,
                date: date, // Mantener como string YYYY-MM-DD
                items: this.products.map(product => ({
                  product: product,
                  initial_stock: 0,
                  ended_stock: 0,
                  added: 0,
                  removed: 0,
                  sold: 0,
                  sent: []
                }))
              }
            }
          }
        })

        return completeStockDaily
      }
    },
    getStocksDailyDates() {
      return this.stocksDaily.reduce((a, v) => {
        if (!a.includes(v.date)) a.push(v.date)
        return a
      }, [])
    },
    getProductAdded() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.added : 0
      }
    },
    getProductRemoved() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.removed : 0
      }
    },
    getProductSold() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item && item.sold ? item.sold : 0
      }
    },
    getProductSent() {
      return (stockDaily, product, branch) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.sent.find(s => s.destination.id === branch.id)?.quantity : 0
      }
    },
    getProductInStock() {
      return (stockDaily, product) => {
        let item = stockDaily.items.find(i => i.product.id === product.id)
        return item ? item.initial_stock : 0
      }
    },
    getProductTotalInStock() {
      return (date, product) => {
        return this.stocksDaily.filter(sd => sd.date === date).reduce((a, v) => {
          let item = v.items.find(i => i.product.id === product.id)
          return a + (item ? item.stock : 0)
        }, 0)
      }
    },
    getBranchSelected() {
      return this.getStockSelected?.branch
    },
    isFactory() {
      return this.getBranchSelected?.role === 'FACTORY'
    },
    isSales() {
      return this.getBranchSelected?.role === 'SALES'
    },
    isHybrid() {
      return this.getBranchSelected?.role === 'HYBRID'
    },
    getBranchs() {
      return this.branchs.filter(b => b.id !== this.getBranchSelected.id) || []
    },
    getTypeStocksLength() {
      let quentity = 4 // Stock, Reposicion y Baja y sold
      let branchsLength = this.getBranchs.length // Sent Branchs length
      return quentity + branchsLength
    }
  },

  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight
    },
    fetchStockDaily() {
      return new Promise((resolve) => {
        this.loading = true
        StockDailyProvider.fetchStockDailyFromDate(this.date)
            .then(r => {
              this.stocksDaily = r.data.fetchStockDailyFromDate
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
    fetchProduct() {
      return new Promise((resolve) => {

        this.loading = true
        ProductProvider.fetchProduct()
            .then(r => {
              this.products = r.data.fetchProduct
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
    fetchStock() {
      return new Promise((resolve) => {
        this.loading = true
        StockProvider.fetchStock()
            .then(r => {
              this.stocks = r.data.fetchStock
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    },
    fetchBranch() {
      return new Promise((resolve) => {
        this.loading = true
        BranchProvider.fetchBranch()
            .then(r => {
              this.branchs = r.data.fetchBranch
            })
            .finally(() => {
              this.loading = false
              resolve()
            })
      })
    }
  }
}
</script>

<style scoped>

</style>
